import { render, staticRenderFns } from "./ScoresSpiderChart.vue?vue&type=template&id=53687ff2&scoped=true"
import script from "./ScoresSpiderChart.vue?vue&type=script&lang=js"
export * from "./ScoresSpiderChart.vue?vue&type=script&lang=js"
import style0 from "./ScoresSpiderChart.vue?vue&type=style&index=0&id=53687ff2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53687ff2",
  null
  
)

export default component.exports